import React from 'react';
import Flagship from '../../core/flagship';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader'
import {getFormattedValue} from '../../utils/helpers';
import { Card, Icon, Button, Loader } from 'semantic-ui-react';


export default class Proposal extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.getFiles = this.getFiles.bind(this);
        this.getSignedUrl = this.getSignedUrl.bind(this);
        this.uploadError = this.uploadError.bind(this);
        this.missingFiles = this.missingFiles.bind(this);
        this.onViewDownloadFile = this.onViewDownloadFile.bind(this);
        this.uploadProgress = this.uploadProgress.bind(this);
        this.uploaderChildren = this.uploaderChildren.bind(this);

        this.s3Url = 'https://' + Flagship.config.awsBucket + '.s3.amazonaws.com';
        this.state = {
            files: [],
            loading:true,
            uploading:false,
            progress:0
        }
    }

    componentDidMount() {
        this.getFiles();
    }

    handleFinishedUpload(data) {
        this.getFiles();
        Flagship.notify(
            "Proposal Uploaded.", "success"
        );
        Flagship.event(
            "proposal-upload",
            data.file.name,
            this.props.recordId,
            this.props.userId
        );
    }

    uploadError(err) {
        Flagship.error("Proposal upload failed. " + err, this.props.recordId, this.props.userId);
    }

    getFiles() {
        let self = this;
        Flagship.get(
            's3/list',
            {
                bucket: Flagship.config.awsBucket,
                folder: self.props.folder,
            },
            function(response) {

                if (response.data.success === true && response.data.files !== null) {
                    self.setState({
                        files: response.data.files,
                        loading: false
                    }, function() {
                        self.props.hasContract(response.data.files.length !== 0)
                    });
                } else if (response.data.files === null) {
                    self.setState({
                        loading: false
                    }, function() {
                        self.props.hasContract(false);
                    });
                } else {
                    Flagship.error("Failed to get proposal file.", self.props.recordId, self.props.userId);
                }

            },
            function(err) {
                Flagship.error("Failed to get proposal file: " + err,  self.props.recordId, self.props.userId);
            }
        );
    }

    getSignedUrl(file, callback) {
        let self = this;
        Flagship.get(
            's3/sign',
            {
                bucket: Flagship.config.awsBucket,
                objectName: self.props.folder + '/' + file.name,
                contentType: file.type,
            },
            function(data) {
                callback(data.data);
            },
            function(err) {
                if (typeof console.error === "function") {
                    console.error(err);
                }
            }
        );
    }

    onViewDownloadFile(file) {
        window.open(Flagship.config.apiBase + 'file?path=' + file);
    }

    missingFiles() {
        return (
            this.state.loading ?
                <Loader color="blue" className="flagship-loader" active inline='centered' /> :
                <div className="cf no-files-found">No files found.</div>
        );
    }

    uploadProgress(uploader, progress) {
        this.setState({
            uploading:true,
            progress
        });
    }


    uploaderChildren() {
        if (this.state.uploading) {
            return (
                <div className="upload-progress-proposal">
                    <div className="uploading-text">{typeof this.state.progress === "number" ? this.state.progress + "%" : this.state.progress}</div>
                </div>
            );
        }
        return (
            <p className="uploader-inner-proposal">
                <Button content={"Upload " + (this.props.recordType === "rfp" ? "Proposal" : "Contract")} />
            </p>
        );
    }

    render() {

        let self = this;
        let children = this.uploaderChildren;

        const uploadOptions = {
            server: 'http://flagship.dev',
            s3path: this.props.folder,
            getSignedUrl: this.getSignedUrl,
            uploadRequestHeaders: {},
            accept: "application/pdf, application/vnd.ms-*, "
        };

        if ( self.state.files.length ) {

            let file = self.state.files[0];

            if (this.props.recordType === "rfp" && this.props.recordStatus === "priced") {
                this.props.onStatusChange(null, {value: "proposal"});
            }

            return (
                <div className="proposal-file">
                    <Card fluid className="single-file">

                        <Card.Content>
                            <h3 className="attachment-record-link">
                                <Icon className="feed-icon" disabled size="large" color="grey" name="file text outline" />
                                {file.Key.replace(/^.*[\\\/]/, '')}
                            </h3>
                            <Card.Meta>{getFormattedValue(file.Size,"filesize")}</Card.Meta>
                            <Card.Description>
                                {getFormattedValue(file.LastModified,"time ago")}
                            </Card.Description>
                            <Card.Content extra>
                                <br/>
                                <div className="ui file-actions">
                                    <Button basic primary onClick={() => {
                                        self.onViewDownloadFile(file.Key)
                                    }}>View / Download</Button>
                                </div>
                            </Card.Content>
                        </Card.Content>
                    </Card>
                </div>

            );
        } else if (this.state.loading === false ) {

            if (this.props.recordType === "rfp" &&
                this.props.recordStatus !== "priced" &&
                this.props.recordStatus !== "trash") {
                this.props.onStatusChange(null, {value: "priced"});
            }

            return (
                <DropzoneS3Uploader
                    onFinish={this.handleFinishedUpload.bind(this)}
                    onProgress={this.uploadProgress}
                    onError={this.uploadError}
                    children={children}
                    passChildrenProps={false}
                    s3Url={this.s3Url}
                    maxSize={1024 * 1024 * 100}
                    upload={uploadOptions}
                    className="file-upload-area"
                    style={
                        {
                            width: '100%',
                            height: 100,
                            border: 'dashed 2px #999',
                            borderRadius: 5,
                            position: 'relative',
                            cursor: 'pointer',
                            overflow: 'hidden',
                        }
                    }
                />
            );
        } else {
            return (
                <div className="center-text">
                    <Loader className="flagship-loader" active inline='centered' />
                    <div>Looking for file...</div>
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/records/Proposal.js